import { sizes, spacings } from "@/assets/themes";
import { BUTTON } from "@/components/Styles/variants";
import polyglot from "@/utils/polyglot";
import { Avatar, Block, Body16, Button, H2, Modal } from "../../components";
import { RECURRING_JOBS_NEW_PATH } from "../dashboard/config/routes";

const JobSuccessModal = ({ onClose, isOpen, jobber = {} }) => (
  <Modal.Small isOpen={isOpen} fullScreenOnMobile onClose={onClose}>
    <Modal.Item.Header onClose={onClose} />
    <Modal.Item.Wrapper>
      <Block
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={spacings.m}
      >
        <Avatar
          src={jobber.avatar}
          name={jobber.first_name}
          size={sizes.size128}
          isTopJobber={jobber.is_top_jobber}
        />
        <Block
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={spacings.s}
        >
          <H2 align="center">{polyglot.t("jobs.recurring_success_title")}</H2>
          <Body16 align="center">
            {polyglot.t("jobs.recurring_success_subtitle")}
          </Body16>
        </Block>
      </Block>
    </Modal.Item.Wrapper>
    <Modal.Item.Footer column>
      <Button.Large block onClick={onClose}>
        {polyglot.t("jobs.see_my_job")}
      </Button.Large>
      <Button.Large
        block
        kind={BUTTON.KIND.SECONDARY}
        href={`${RECURRING_JOBS_NEW_PATH}?jobber_id=${jobber.id}`}
      >
        {polyglot.t("jobs.add_recurring")}
      </Button.Large>
    </Modal.Item.Footer>
  </Modal.Small>
);

export default JobSuccessModal;
